export function processIconsInText(text) {
  let result = text;

  result = result.replace(
    /\{icon-(\d+)\}(?:\s|&nbsp;|&#160;)*<strong([^>]*)>(.*?)<\/strong>/g,
    (match, iconNum, strongAttrs, strongContent) => {
      const hasNbsp =
        strongContent.trim().startsWith('&nbsp;') ||
        strongContent.trim().startsWith('&#160;');
      const spacer = hasNbsp ? '' : ' ';

      let cleanContent = strongContent.trim();
      if (hasNbsp) {
        cleanContent = cleanContent.replace(/^(?:&nbsp;|&#160;)/, '').trim();
      }

      const words = cleanContent.split(/\s+/);
      const firstWord = words[0];
      const restContent =
        words.length > 1 ? ' ' + words.slice(1).join(' ') : '';
      return `<strong${strongAttrs}><span style="white-space: nowrap">{icon-${iconNum}}${hasNbsp ? '&nbsp;' : spacer}${firstWord}</span>${restContent}</strong>`;
    },
  );

  result = result.replace(
    /<strong([^>]*)>\{icon-(\d+)\}(.*?)<\/strong>/g,
    (match, strongAttrs, iconNum, strongContent) => {
      const hasNbsp =
        strongContent.trim().startsWith('&nbsp;') ||
        strongContent.trim().startsWith('&#160;');
      const spacer = hasNbsp ? '' : ' ';

      let cleanContent = strongContent.trim();
      if (hasNbsp) {
        cleanContent = cleanContent.replace(/^(?:&nbsp;|&#160;)/, '').trim();
      }

      const words = cleanContent.split(/\s+/);
      const firstWord = words[0];
      const restContent =
        words.length > 1 ? ' ' + words.slice(1).join(' ') : '';

      return `<strong${strongAttrs}><span style="white-space: nowrap">{icon-${iconNum}}${hasNbsp ? '&nbsp;' : spacer}${firstWord}</span>${restContent}</strong>`;
    },
  );

  return result;
}
